export type GameDataModel = {
  id: string
  thumbnailImagePath: string
  coverImagePath: string
  coverVideoPath: string | null
  title: string
  subtitle: string
  description: string
  tags: string[]
  actions: Array<{
    label: string | null | undefined
    icon: string | null | undefined
    buttonColor: string | null
    contentColor: string | null
    link: string
  }>
}

export const gamesCachedValue: GameDataModel[] = [
  {
    id: 'splitsease',
    thumbnailImagePath: 'games/splitsease/thumbnail.jpg',
    coverImagePath: 'games/splitsease/cover.jpg',
    coverVideoPath: '',
    title: 'Splitsease',
    subtitle: 'Android, iOS App',
    description:
      'Splitsease is the simplest way to share group expenses, split bills, track who owes whom, remind and settle up effortlessly. No messy notes, forgotten debts or complicated spreadsheets. 100% transparent expense sharing. Zero awkwardness.',
    tags: ['Android', 'iOS', 'App', 'Lifestyle', 'Expense'],
    actions: [
      {
        label: 'Apple App Store',
        icon: 'apple_app_store',
        buttonColor: '#7BFAFF',
        contentColor: '#212121',
        link: 'https://apps.apple.com/us/app/splitsease-split-bills/id6747746175',
      },
      {
        label: 'Google Play',
        icon: 'google_play',
        buttonColor: '#7BFAFF',
        contentColor: '#212121',
        link: 'https://play.google.com/store/apps/details?id=com.yarncat.splitsies',
      },
    ],
  },
  {
    id: 'dragunamatata',
    thumbnailImagePath: 'games/dragunamatata/thumbnail.jpg',
    coverImagePath: 'games/dragunamatata/cover.png',
    coverVideoPath: 'games/dragunamatata/cover.mp4',
    title: "Draguna Matata",
    subtitle: 'Steam - PC and Mac',
    description:
      "Draguna Matata is a challenging puzzle game where you, a dragon baby, slither out of increasingly complex mazes in a rainforest. Grow bigger, gain powers, push boxes, and control the environment... all so that you can receive some solid unsolicited advice from the friends you make along the way!",
    tags: [
      'Steam',
      'PC',
      'Mac',
      'Puzzle',
      'Narrative',
      'Top 100 in GMTK Game Jam 2024',
    ],
    actions: [
      {
        label: 'Steam',
        icon: 'google_play',
        buttonColor: '#7BFAFF',
        contentColor: '#212121',
        link:
          'https://store.steampowered.com/app/3414530/Draguna_Matata/',
      },
    ],
  },
  {
    id: 'youtube',
    thumbnailImagePath: 'games/youtube/thumbnail.png',
    coverImagePath: 'games/youtube/cover.png',
    coverVideoPath: null,
    title: "Yarncat on YouTube",
    subtitle: 'Game Development Videos',
    description:
      "Explore our YouTube channel for game development videos, including behind-the-scenes content, tutorials, and career development advice.",
    tags: [
      'Youtube',
      'Career Development',
      'Game Development',
    ],
    actions: [
      {
        label: 'View on YouTube',
        icon: 'youtube',
        buttonColor: '#E96063',
        contentColor: '#FFFFFF',
        link: 'https://www.youtube.com/@YarncatStudios',
      },
    ],
  },
  {
    id: 'tidesend',
    thumbnailImagePath: 'games/tidesend/thumbnail.webp',
    coverImagePath: 'games/tidesend/cover.webp',
    coverVideoPath: 'games/tidesend/cover.mp4',
    title: "Tide's End",
    subtitle: 'Android, iOS App',
    description:
      "Set against the vast and mysterious backdrop of the ocean by the tiny village of Tide's End, this game combines intricate puzzle mechanics with a captivating narrative that will keep players hooked from beginning to end.",
    tags: [
      'Android',
      'iOS',
      'Game',
      'Puzzle',
      'Narrative',
      'Top 100 in Brackey’s Jam 2023.2',
    ],
    actions: [
      {
        label: null,
        icon: 'terms_of_service',
        buttonColor: '#FBFEFE',
        contentColor: '#212121',
        link: 'https://www.yarncat.co.uk/tidesend-eula',
      },
      {
        label: null,
        icon: 'privacy_policy',
        buttonColor: '#FBFEFE',
        contentColor: '#212121',
        link: 'https://www.yarncat.co.uk/tidesend-privacypolicy',
      },
      {
        label: 'App Store',
        icon: 'apple_app_store',
        buttonColor: '#7BFAFF',
        contentColor: '#212121',
        link: 'https://apps.apple.com/us/app/tides-end/id6471380375',
      },
      {
        label: 'Google Play',
        icon: 'google_play',
        buttonColor: '#7BFAFF',
        contentColor: '#212121',
        link:
          'https://play.google.com/store/apps/details?id=com.yarncat.tidesend',
      },
    ],
  },
  {
    id: 'reverb',
    thumbnailImagePath: 'games/reverb/thumbnail.webp',
    coverImagePath: 'games/reverb/cover.webp',
    coverVideoPath: 'games/reverb/cover.mp4',
    title: 'Reverb',
    subtitle: 'Android, iOS App',
    description:
      "In the ever-changing battleground of Reverb, can you keep up with the multiplying threats? Surviving won't be as easy as it seems, especially when echoes morphs into a new enemy. We invite you to a vibrant neon world, where a bounce can reverberate into a new challenge",
    tags: ['Android', 'iOS', 'Game', 'Shooter', 'Arcade'],
    actions: [
      {
        label: null,
        icon: 'terms_of_service',
        buttonColor: '#FBFEFE',
        contentColor: '#212121',
        link: 'https://www.yarncat.co.uk/reverb-eula',
      },
      {
        label: null,
        icon: 'privacy_policy',
        buttonColor: '#FBFEFE',
        contentColor: '#212121',
        link: 'https://www.yarncat.co.uk/reverb-privacypolicy',
      },
      {
        label: 'App Store',
        icon: 'apple_app_store',
        buttonColor: '#7BFAFF',
        contentColor: '#212121',
        link: 'https://apps.apple.com/us/app/reverb-arcade/id6450632212',
      },
      {
        label: 'Google Play',
        icon: 'google_play',
        buttonColor: '#7BFAFF',
        contentColor: '#212121',
        link:
          'https://play.google.com/store/apps/details?id=com.yarncat.reverb',
      },
    ],
  },
  {
    id: 'jotjournal',
    thumbnailImagePath: 'games/jotjournal/thumbnail.webp',
    coverImagePath: 'games/jotjournal/cover.webp',
    coverVideoPath: 'games/jotjournal/cover.mp4',
    title: 'Jot Journal',
    subtitle: 'Android App',
    description:
      'Introducing the ultimate journaling app for individuals who are looking for an organised and fulfilling life. Our app provides a simple and intuitive platform to help you keep track of your daily routines and reflect on your thoughts and experiences. ',
    tags: ['Android', 'App', 'Lifestyle', 'Diary'],
    actions: [
      {
        label: null,
        icon: 'privacy_policy',
        buttonColor: '#FBFEFE',
        contentColor: '#212121',
        link: 'https://www.yarncat.co.uk/jotjournalpolicy',
      },
      {
        label: 'Google Play',
        icon: 'google_play',
        buttonColor: '#7BFAFF',
        contentColor: '#212121',
        link: 'https://play.google.com/store/apps/details?id=com.yarncat.diary',
      },
    ],
  },
  {
    id: 'itch',
    thumbnailImagePath: 'games/itch/thumbnail.webp',
    coverImagePath: 'games/itch/cover.webp',
    coverVideoPath: 'games/itch/cover.mp4',
    title: 'Itch Catalogue',
    subtitle: 'Game Prototypes',
    description:
      'Our game catalogue on Itch.io, featuring a variety of game prototypes and jam entries',
    tags: [
      'Game Jam',
      'Top 10 in Brackey’s Jam 2025.1',
      'Top 25 in Brackey’s Jam 2024.1',
      'Top 100 in Brackey’s Jam 2023.2',
      'Top 100 in GMTK Game Jam 2024',
      'Top 300 in GMTK Game Jam 2023',
    ],
    actions: [
      {
        label: 'View on Itch',
        icon: 'itch',
        buttonColor: '#E96063',
        contentColor: '#FFFFFF',
        link: 'https://bijoykochar.itch.io/',
      },
    ],
  },
]
